import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Login from '../components/Login/Login'
import PrivateRoute from './PrivateRoute'
import ViewHistory from '../pages/EmployeeViewHistory/ViewHistoryVehicle'
import OperationsHub from '../components/OperationsHub'
import Scan from '../components/Scan'

const AppRoute = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route index element={<PrivateRoute><OperationsHub /></PrivateRoute>} />
            <Route path="/employee/manage-vehicle/*" element={<PrivateRoute><OperationsHub /></PrivateRoute>} />
            <Route path="/scan" element={<PrivateRoute><Scan /></PrivateRoute>} />
            <Route path='/history' element={<PrivateRoute><ViewHistory /></PrivateRoute>} />
            <Route path='/employee/view-history-vehicle/*' element={<PrivateRoute><ViewHistory /></PrivateRoute>} />
            {/* Fallback route */}
            <Route path='*' element={<PrivateRoute><OperationsHub /></PrivateRoute>} />
        </Routes>
    )
}

export default AppRoute
